import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { User } from '../_models/user';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../_models/pagination';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ChangePassword } from '../_models/changepassword';
import { ResetPassword } from '../_models/resetpassword';
import { UserForDetails } from '../_models/user/userForDetails';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  baseUrl = environment.apiUrl;

constructor(private http: HttpClient) { }
  get token(){return localStorage.getItem('token')}
  getUsers(page?, itemPerPage?): Observable<PaginatedResult<User[]>> {
    const paginatedResult: PaginatedResult<User[]> = new PaginatedResult<User[]>();

    let params = new HttpParams();

    if (page != null && itemPerPage != null) {
      params = params.append('pageNumber', page);
      params = params.append('pageSize', itemPerPage);
    }
    return this.http.get<User[]>(this.baseUrl + 'users', {observe: 'response', params})
      .pipe(
        map(response => {
          paginatedResult.result = response.body;
          if (response.headers.get('Pagination') != null) {
            paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
          }
          return paginatedResult;
      })
    );
  }

  // getUserDetails(id): Observable<UserForDetails> {
  //   return this.http.get<UserForDetails>(this.baseUrl + 'users/GetUser/' + id);
  // }

  //ok
  async getUserDetails(id){
    return await this.http.get(this.baseUrl + 'users/GetUser/' + id).toPromise();
  }

  //ok
  getCurrentUserInfo(): Observable<UserForDetails> {
    return this.http.get<UserForDetails>(this.baseUrl + 'users/GetCurrentUserInfo', { headers: { Authorization: 'Bearer ' + this.token } });
  }

  getCurrentUserInfoWithAwait() {
    return this.http.get<UserForDetails>(this.baseUrl + 'users/GetCurrentUserInfo', { headers: { Authorization: 'Bearer ' + this.token } }).toPromise();
  }

  //ok
  updateUser(id: number, user: User) {
    return this.http.put(this.baseUrl + 'users/' + id, user);
  }

  changePassword(currentPassword: ChangePassword) {
    return this.http.post(this.baseUrl + 'users/changepassword', currentPassword);
  }

  resetPassword(resetPassword: ResetPassword) {
    return this.http.post(this.baseUrl + 'users/resetpassword', resetPassword);
  }
}
